module.exports = __webpack_public_path__ + "img/389.56e74fb5.jpg";